import { List } from '@hai/ui-react';
import React, { useEffect } from 'react';
import { SortDirection, SortManager } from 'src/js/component/sort-manager';
import { scrollPanelIntoView } from 'src/js/component/actionBar/streaming-action-bar';
import { constant } from 'src/js/constant';

import { ScteViewModel } from './scte-models';
import { ScteRow } from './scte-row';

interface ScteProps {
  list: ScteViewModel[];
  direction: SortDirection;
  onSelect: (model: ScteViewModel, selected: boolean) => void;
  sorting: string;
  sortInfo: any;
  scrollToId: number | string;
}

export const ScteList: React.FunctionComponent<ScteProps> = ({
  list,
  direction,
  onSelect,
  sorting,
  sortInfo,
  scrollToId,
}) => {
  useEffect(() => {
    scrollPanelIntoView({ id: scrollToId });
  }, []);

  return (
    <List accentColor={constant.productColor}>
      <SortManager sortInfo={sortInfo} list={list} sortKey={sorting} direction={direction} secondLevelSortKey="name">
        {list &&
          list.map((model: ScteViewModel) => {
            return <ScteRow key={model.id} model={model} onSelect={onSelect} scrollToId={scrollToId} />;
          })}
      </SortManager>
    </List>
  );
};
